import classes from "./ToolBar.module.css";
import {Button, Group} from "@mantine/core";
import {IconArrowRight} from "@tabler/icons-react";
import MoreButton, {MoreButtonProps} from "./more-button/MoreButton";

type ToolBarPropsBase = {
    /**
     * Label to be displayed.
     * @author Kacper Faber
     * @since 0.1.9
    */
    label: string;
};

export type ToolBarProps = ToolBarPropsBase & MoreButtonProps;

function ToolBar(props: ToolBarProps) {
    return (
        <div className={classes.root}>
            <div className={classes.label}>
                { props.label }
            </div>

            <MoreButton {...props} />
        </div>
    );
}

export default ToolBar;